import { useQuery } from "react-query";
import { getTranslationList } from "../api";
import { API_KEY_GET_TRANSLATION_LIST } from "../constants";

export const useGetTranslationList = (params) => {
  return useQuery([API_KEY_GET_TRANSLATION_LIST, params], () =>
    getTranslationList(params)
  );
};
